import type { OpenBottomType } from '@onl-web/shared/bridge'

export type CompletionToastVariant = Extract<OpenBottomType, 'share' | 'alarm'>

export const isCompletionToastVariant = (value: OpenBottomType): value is CompletionToastVariant =>
  value === 'share' || value === 'alarm'
